module.exports = __webpack_public_path__ + "static/media/and_scr_simple_num_kbd.b235f8a2.png";